export default __webpack_public_path__ + "static/media/banner-tablet-bg-pink-template.48dcb962.svg";